export default "__VITE_ASSET__DQThiDd8__"